import { RotateCcw } from 'lucide-react'

import { Button } from '../ui/button'

import styles from './HomeNbaEmpty.module.scss'

export type HomeNbaEmptyVariant = 'no-priorities' | 'all-reviewed'

/**
 * Empty state rendered in place of the home NBA grid.
 *
 * Two variants, each tied to a genuinely different moment:
 *
 * - `no-priorities` — the firing pool was empty when the payload was
 *   computed. Honest signal: nothing surfaces today, nothing to restore.
 * - `all-reviewed` — the banker dismissed every visible card in this
 *   session. They've done the work; the action below offers a way back,
 *   matching the "dismiss means not now, not never" rule documented in
 *   `src/credem_explorer/services/home_nba/README.md`.
 *
 * The restore button performs a local reset only — NBAs recalculate on
 * the daily cadence, not on demand, so the icon/label intentionally read
 * as "re-examine" rather than "refresh".
 */
export function HomeNbaEmpty({
  variant,
  onRestore,
}: {
  variant: HomeNbaEmptyVariant
  onRestore?: () => void
}) {
  const copy =
    variant === 'all-reviewed'
      ? 'Hai esaminato tutte le priorità di oggi.'
      : 'Nessuna priorità in evidenza oggi.'

  return (
    <div className={styles.root} data-variant={variant}>
      <p className={styles.copy}>{copy}</p>
      {variant === 'all-reviewed' && onRestore ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onRestore}
          aria-label="Riesamina priorità"
          className={styles.restoreButton}
        >
          <RotateCcw aria-hidden />
          Riesamina priorità
        </Button>
      ) : null}
    </div>
  )
}
